<template>
    <div class="page-wrapper">
        <div class="page-container">
        <PageHeader :title="config.pageTitle" :subtitle="config.subtitle" @back="goBack" />

            <div class="content-area">
                <!-- 基本信息卡片 -->
                <PrescriptionCard title="基本信息">
                    <div class="info-grid">
                        <div class="info-item" v-if="consultInfo.contact.name"><span class="info-label">姓名：</span><span
                                class="info-value">{{ consultInfo.contact.name }}</span></div>
                        <div class="info-item" v-if="consultInfo.contact.sex"><span class="info-label">性别：</span><span
                                class="info-value">{{ consultInfo.contact.sex == '1' ? '男' : '女' }}</span></div>
                        <div class="info-item" v-if="consultInfo.contact.phoneNo"><span
                                class="info-label">电话：</span><span class="info-value">{{ consultInfo.contact.phoneNo
                                }}</span></div>
                        <div class="info-item" v-if="consultInfo.contact.birthday">
                            <span class="info-label">出生日期：</span>
                            <span class="info-value">{{ consultInfo.contact.birthday }}<span
                                    v-if="shouldShowTime(consultInfo.contact.birthHour, consultInfo.contact.birthMinute)">
                                    {{ formatTimeValue(consultInfo.contact.birthHour) }}:{{
                                        formatTimeValue(consultInfo.contact.birthMinute) }}</span></span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.liveArea"><span
                                class="info-label">常住地址：</span><span class="info-value">{{ consultInfo.contact.liveArea
                                }}</span></div>
                        <div class="info-item" v-if="consultInfo.contact.birthArea"><span
                                class="info-label">出生地址：</span><span class="info-value">{{ consultInfo.contact.birthArea
                                }}</span></div>
                    </div>
                </PrescriptionCard>

                <!-- 使用信息卡片 -->
                <PrescriptionCard :title="effectiveUseInfoTitle">
                    <div v-if="hasUseInfo" class="info-grid">
                        <div v-if="consultInfo.useDate" class="info-item"><span class="info-label">{{ isChaoweiFlow ? '开始调理时间' : '开始服药时间' }}：</span><span class="info-value">{{
                            consultInfo.useDate }}</span></div>
                        <div v-if="config.showGanZhiLabel&&consultInfo.illDay" class="info-item"><span
                                class="info-label">{{ isChaoweiFlow ? '状况开始时间' : '开始发病时间' }}：</span><span class="info-value">{{ consultInfo.illDay
                                }}</span></div>
                        <div class="info-item" v-if="useDaysValue">
                            <span class="info-label">{{ useDaysLabel }}：</span>
                            <span class="info-value">{{ useDaysValue }}</span>
                        </div>
                    </div>
                    <div v-else class="text-muted">{{ isChaoweiFlow ? '暂无调理信息' : '暂无用药信息' }}</div>
                </PrescriptionCard>

                <!-- 健康问询卡片（条件渲染） -->
                <PrescriptionCard v-if="config.showSymptoms" :title="isChaoweiFlow ? '健康问询' : '症状信息'">
                    <el-form label-width="120px" label-position="right" class="symptom-form"
                        v-if="submitData.basic_array && submitData.basic_enter_array">
                        <WJTRadio v-model="submitData.basic_array[0].value" :label="submitData.basic_array[0].key + '：'"
                            :must="submitData.basic_array[0].must" :disable="radioDisable"
                            :radios="submitData.basic_array[0].options"></WJTRadio>
                        <div class="form-row">
                            <el-form-item :label="submitData.basic_enter_array[0].key + '：'" class="form-item-half">
                                <el-input v-model="submitData.basic_enter_array[0].value" autocomplete="off"
                                    placeholder="请输入体温"></el-input>
                            </el-form-item>
                            <el-form-item :label="submitData.basic_enter_array[1].key + '：'" class="form-item-half">
                                <el-input v-model="submitData.basic_enter_array[1].value" autocomplete="off"
                                    placeholder="请输入脉搏（次/分）"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-row">
                            <el-form-item :label="submitData.basic_enter_array[2].key + '：'" class="form-item-half">
                                <el-input v-model="submitData.basic_enter_array[2].value" autocomplete="off"
                                    placeholder="请输入血压-收缩压（mmHg)"></el-input>
                            </el-form-item>
                            <el-form-item :label="submitData.basic_enter_array[3].key + '：'" class="form-item-half">
                                <el-input v-model="submitData.basic_enter_array[3].value" autocomplete="off"
                                    placeholder="请输入血压-舒张压（mmHg)"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-row">
                            <el-form-item :label="(chaoweiFieldLabel(4) || submitData.basic_enter_array[4].key) + '：'"
                                :class="isChaoweiFlow ? 'form-item-full' : 'form-item-half'">
                                <el-input v-model="submitData.basic_enter_array[4].value" type="textarea"
                                    autocomplete="off"
                                    :placeholder="isChaoweiFlow ? '请输入问询结果' : '请输入主诉'"></el-input>
                            </el-form-item>
                            <el-form-item v-if="!isChaoweiFlow"
                                :label="(chaoweiFieldLabel(5) || submitData.basic_enter_array[5].key) + '：'" class="form-item-half">
                                <el-input v-model="submitData.basic_enter_array[5].value" type="textarea"
                                    autocomplete="off" placeholder="请输入西医诊断结果"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>

                    <!-- 脉象信息 -->
                    <el-form label-width="120px" label-position="right" class="symptom-form"
                        v-if="submitData.basic_array && submitData.maixiang_array">
                        <div class="divider"></div>
                        <div class="form-row">
                            <WJTRadio v-model="submitData.basic_array[1].value"
                                :label="submitData.basic_array[1].key + '：'" :must="submitData.basic_array[1].must"
                                :radios="submitData.basic_array[1].options"
                                :defaultValue="submitData.basic_array[1].defaultValue"></WJTRadio>
                            <WJTRadio v-model="submitData.basic_array[2].value"
                                :label="submitData.basic_array[2].key + '：'" :must="submitData.basic_array[2].must"
                                :radios="submitData.basic_array[2].options"
                                :defaultValue="submitData.basic_array[2].defaultValue"></WJTRadio>
                        </div>
                        <div class="form-row">
                            <WJTRadio v-model="submitData.basic_array[3].value"
                                :label="submitData.basic_array[3].key + '：'" :must="submitData.basic_array[3].must"
                                :radios="submitData.basic_array[3].options"
                                :defaultValue="submitData.basic_array[3].defaultValue"></WJTRadio>
                            <WJTRadio v-model="submitData.basic_array[4].value"
                                :label="submitData.basic_array[4].key + '：'" :must="submitData.basic_array[4].must"
                                :radios="submitData.basic_array[4].options"
                                :defaultValue="submitData.basic_array[4].defaultValue"></WJTRadio>
                        </div>
                        <div class="form-row">
                            <WJTRadio v-model="submitData.maixiang_array[0].value"
                                :label="submitData.maixiang_array[0].key + '：'"
                                :must="submitData.maixiang_array[0].must" :radios="submitData.maixiang_array[0].options"
                                :defaultValue="submitData.maixiang_array[0].defaultValue"></WJTRadio>
                            <WJTRadio v-model="submitData.maixiang_array[1].value"
                                :label="submitData.maixiang_array[1].key + '：'"
                                :must="submitData.maixiang_array[1].must" :radios="submitData.maixiang_array[1].options"
                                :defaultValue="submitData.maixiang_array[1].defaultValue"></WJTRadio>
                        </div>
                        <div class="form-row">
                            <WJTRadio v-model="submitData.maixiang_array[2].value"
                                :label="submitData.maixiang_array[2].key + '：'"
                                :must="submitData.maixiang_array[2].must" :radios="submitData.maixiang_array[2].options"
                                :defaultValue="submitData.maixiang_array[2].defaultValue"></WJTRadio>
                            <WJTRadio v-model="submitData.maixiang_array[3].value"
                                :label="submitData.maixiang_array[3].key + '：'"
                                :must="submitData.maixiang_array[3].must" :radios="submitData.maixiang_array[3].options"
                                :defaultValue="submitData.maixiang_array[3].defaultValue"></WJTRadio>
                        </div>
                        <div class="form-row">
                            <WJTRadio v-model="submitData.maixiang_array[4].value"
                                :label="submitData.maixiang_array[4].key + '：'"
                                :must="submitData.maixiang_array[4].must" :radios="submitData.maixiang_array[4].options"
                                :defaultValue="submitData.maixiang_array[4].defaultValue"></WJTRadio>
                            <WJTRadio v-model="submitData.maixiang_array[5].value"
                                :label="submitData.maixiang_array[5].key + '：'"
                                :must="submitData.maixiang_array[5].must" :radios="submitData.maixiang_array[5].options"
                                :defaultValue="submitData.maixiang_array[5].defaultValue"></WJTRadio>
                        </div>
                    </el-form>
                </PrescriptionCard>

                <!-- 三焦信息卡片（条件渲染） -->
                <PrescriptionCard v-if="config.showSymptoms" :title="isChaoweiFlow ? '三焦情况' : '三焦辨证'">
                    <div class="sanjiao-list">
                        <div class="sanjiao-group" v-if="submitData.shangjiao_array">
                            <div class="sanjiao-group-title">上焦</div>
                            <div class="sanjiao-tags" v-for="shangjiao in submitData.shangjiao_array"
                                :key="shangjiao.key">
                                <div class="group-label-simple">{{ shangjiao.key }}：</div>
                                <el-checkbox-group v-model="shangjiao.value">
                                    <el-checkbox-button v-for="option in shangjiao.options" :label="option"
                                        :key="option">{{ option }}</el-checkbox-button>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="sanjiao-group" v-if="submitData.zhongjiao_array">
                            <div class="sanjiao-group-title">中焦</div>
                            <div class="sanjiao-tags" v-for="zhongjiao in submitData.zhongjiao_array"
                                :key="zhongjiao.key">
                                <div class="group-label-simple">{{ zhongjiao.key }}：</div>
                                <el-checkbox-group v-model="zhongjiao.value">
                                    <el-checkbox-button v-for="option in zhongjiao.options" :label="option"
                                        :key="option">{{ option }}</el-checkbox-button>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="sanjiao-group" v-if="submitData.xiajiao_array">
                            <div class="sanjiao-group-title">下焦</div>
                            <div class="sanjiao-tags" v-for="xiajiao in submitData.xiajiao_array" :key="xiajiao.key">
                                <div class="group-label-simple">{{ xiajiao.key }}：</div>
                                <el-checkbox-group v-model="xiajiao.value">
                                    <el-checkbox-button v-for="option in xiajiao.options" :label="option"
                                        :key="option">{{ option }}</el-checkbox-button>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </PrescriptionCard>

                <!-- 提交按钮 -->
                <div class="btn-area">
                    <el-button class="btn-submit" type="primary" @click="submit">{{ submitBtnText }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrescriptionCard from './PrescriptionCard.vue'
import PageHeader from '@/components/widgets/PageHeader.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
import form from '../../js/form'

export default {
    name: 'PrescriptionInfoPage',
    components: {
        PrescriptionCard,
        PageHeader,
        WJTRadio,
    },
    props: {
        config: {
            type: Object,
            default: () => ({
                pageTitle: '处方信息',
                subtitle: '',
                useInfoTitle: '处方使用信息',
                showSymptoms: false,
                submitRouteMode1: '/prescriptionResult',
                submitRouteMode2: '/handmadePrescription',
                btnTextMode1: '提交处方信息',
                btnTextMode2: '请输入药方',
                showGanZhiLabel: false,
                supportMode: false,
            }),
        },
    },
    data() {
        return {
            consultInfo: {
                contact: {},
                useDate: '',
                useDays: '',
            },
            submitData: {},
            activeNames: '',
            radioDisable: false,
            mode: 1,
        }
    },
    computed: {
        submitBtnText() {
            if (this.config.supportMode) {
                return this.mode == 1 ? this.config.btnTextMode1 : this.config.btnTextMode2
            }
            return this.config.btnTextMode1
        },
        isChaoweiFlow() {
            return this.$route.path.indexOf('chaowei') !== -1
        },
        effectiveUseInfoTitle() {
            if (this.isChaoweiFlow) return '使用信息'
            return this.config.useInfoTitle
        },
        hasUseInfo() {
            return !!(this.consultInfo.useDate || this.consultInfo.ganZhiPrescriptionHourRange)
        },
        useDaysLabel() {
            if (this.isChaoweiFlow) {
                return this.consultInfo.ganZhiPrescriptionHourRange ? '服用时段' : '调理天数'
            }
            if (!this.config.showGanZhiLabel) return '服药天数'
            return this.consultInfo.ganZhiPrescriptionHourRange ? '服用时间段' : '服药天数'
        },
        useDaysValue() {
            if (this.isChaoweiFlow) {
                return this.consultInfo.ganZhiPrescriptionHourRange || this.consultInfo.useDays
            }
            if (this.consultInfo.ganZhiPrescriptionHourRange) return this.consultInfo.ganZhiPrescriptionHourRange
            return this.consultInfo.useDays
        },
    },
    created() {
        if (this.config.supportMode && this.$route.query.mode) {
            this.mode = Number(this.$route.query.mode)
        }
        // 检查缓存是否存在/有效，缺失则跳转首页
        var consultStr = sessionStorage.getItem('consultInfo')
        var consult = null
        if (this.utils.isEmptyStr(consultStr)) {
            this.$router.replace('/')
            return
        }
        try {
            consult = JSON.parse(consultStr)
        } catch (e) {
            this.$router.replace('/')
            return
        }
        // 如果 contact 字段缺失或为空对象，说明缓存已被破坏（订单提交后被清空），跳转首页
        if (this.utils.isEmptyObject(consult) || this.utils.isEmptyObject(consult.contact)) {
            this.$router.replace('/')
            return
        }
        var submitData = sessionStorage.getItem('submitData')
        if (this.utils.isEmptyStr(submitData)) {
            for (var i = 0; i < form.basic_array.length; i++) {
                form.basic_array[i].value = i == 0 ? '否' : '正常'
            }
            for (var i = 0; i < form.basic_enter_array.length; i++) {
                form.basic_enter_array[i].value = ''
            }
            for (var i = 0; i < form.maixiang_array.length; i++) {
                form.maixiang_array[i].value = '正常'
            }
            for (var i = 0; i < form.shangjiao_array.length; i++) {
                form.shangjiao_array[i].value = []
            }
            for (var i = 0; i < form.zhongjiao_array.length; i++) {
                form.zhongjiao_array[i].value = []
            }
            for (var i = 0; i < form.xiajiao_array.length; i++) {
                form.xiajiao_array[i].value = []
            }
            this.submitData = form
        } else {
            this.submitData = JSON.parse(submitData)
        }
        var consult = JSON.parse(consultStr)
        if (!this.utils.isEmptyObject(consult) && !this.utils.isEmptyObject(consult.contact)) {
            this.consultInfo = consult
            this.radioDisable = consult.contact.sex == '1'
        } else {
            this.$router.replace('/')
        }
    },
    methods: {
        chaoweiFieldLabel(idx) {
            if (!this.isChaoweiFlow) return null
            if (idx === 4 || idx === 5) return '问询结果'
            return null
        },
        shouldShowTime(hour, minute) {
            return !(this.isEmptyValue(hour) && this.isEmptyValue(minute))
        },
        isEmptyValue(value) {
            return value === '' || value === null || value === undefined
        },
        formatTimeValue(value) {
            if (value === '-1' || value === -1 || value === '--') {
                return '--'
            }
            return value
        },
        goBack() {
            this.$router.go(-1)
        },
        submit() {
            sessionStorage.setItem('submitData', JSON.stringify(this.submitData))
            if (this.config.supportMode) {
                this.$router.push(this.mode == 1 ? this.config.submitRouteMode1 : this.config.submitRouteMode2)
            } else {
                this.$router.push(this.config.submitRouteMode1)
            }
        },
    },
}
</script>

<style scoped>
.page-wrapper {
    min-height: 100vh;
    background: #fbfcfa;
}

.page-container {
    max-width: 1152px;
    margin: 0 auto;
    padding: 32px 24px 80px;
}



/* 内容区域 */
.content-area {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* 信息网格 */
.info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.info-item {
    display: flex;
    align-items: center;
    border: 1px solid #edf0ec;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 18px;
    line-height: 1.5;
}

.info-label {
    color: #1a1a1a;
    flex-shrink: 0;
    min-width: 130px;
    font-size: 18px;
}

.info-value {
    color: #1a1a1a;
    font-weight: 500;
    font-size: 18px;
}

.text-muted {
    color: #aaa;
    font-size: 18px;
}

/* 表单样式 */
.symptom-form {
    width: 100%;
}

.symptom-form>>>.el-form-item__label {
    color: #555;
    font-size: 18px !important;
}

.symptom-form>>>.el-input__inner {
    border-radius: 8px;
    border-color: #e6ede8;
    font-size: 18px;
}

.symptom-form>>>.el-input__inner:focus {
    border-color: #20863F;
}

.symptom-form>>>.el-textarea__inner {
    border-radius: 8px;
    border-color: #e6ede8;
    font-size: 18px;
}

.symptom-form>>>.el-textarea__inner:focus {
    border-color: #20863F;
}

.symptom-form>>>.el-radio-button__inner {
    font-size: 18px !important;
}

.symptom-form>>>.el-checkbox-button__inner {
    font-size: 18px !important;
}

.form-row {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 4px;
}

.form-row>>>.el-form-item {
    margin-bottom: 12px;
}

.form-item-half {
    width: 50%;
}

.form-item-full {
    width: 100%;
}

.divider {
    height: 1px;
    background: #eee;
    margin: 8px 0 16px;
    width: 100%;
}

/* 三焦样式 */
.sanjiao-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.sanjiao-group {
    border: 1px solid #edf0ec;
    border-radius: 12px;
    padding: 16px;
}

.sanjiao-group-title {
    font-size: 18px;
    font-weight: 600;
    color: #20863F;
    margin-bottom: 12px;
}

.sanjiao-tags {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 18px;
}

.sanjiao-tags:last-child {
    margin-bottom: 0;
}

.group-label-simple {
    font-size: 18px;
    color: #555;
    flex-shrink: 0;
    min-width: 130px;
    text-align: right;
}

.sanjiao-tags>>>.el-checkbox-button__inner {
    border: 1px solid #e3e6e1;
    border-radius: 6px;
    padding: 4px 12px;
    font-size: 18px;
    color: #555;
    background: #fff;
    line-height: 25px;
}

.sanjiao-tags>>>.el-checkbox-button.is-checked .el-checkbox-button__inner {
    background: #20863F;
    border-color: #20863F;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(42, 122, 75, 0.25);
}

.sanjiao-tags>>>.el-checkbox-button:first-child .el-checkbox-button__inner {
    border-radius: 6px;
}

.sanjiao-tags>>>.el-checkbox-button:last-child .el-checkbox-button__inner {
    border-radius: 6px;
}

.sanjiao-tags>>>.el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.sanjiao-tags>>>.el-checkbox-button {
    margin: 0;
}

/* 提交按钮区域 */
.btn-area {
    display: flex;
    justify-content: center;
    padding-top: 12px;
}

.btn-submit {
    width: 100%;
    max-width: 680px;
    height: 56px;
    border-radius: 12px;
    background: #20863F;
    border: none;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    box-shadow: 0 8px 20px rgba(42, 122, 75, 0.25);
    transition: all 0.2s;
}

.btn-submit:hover {
    background: #21633d;
    box-shadow: 0 12px 28px rgba(42, 122, 75, 0.35);
}

.btn-submit:active {
    background: #1a522f;
}

/* Response */
@media (max-width: 768px) {
    .page-container {
        padding: 20px 16px 60px;
    }

    .content-area {
        gap: 20px;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .form-row {
        flex-direction: column;
        gap: 0;
    }

    .form-item-half {
        width: 100%;
    }

    .sanjiao-tags {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        margin-bottom: 14px;
    }

    .group-label-simple {
        width: 100%;
        text-align: left;
        font-weight: 500;
        color: #333;
        font-size: 15px;
    }

    .sanjiao-tags>>>.el-checkbox-group {
        width: 100%;
    }

    .symptom-form>>>.el-form-item__label {
        width: 100% !important;
        text-align: left;
        float: none;
        line-height: 1.4;
        padding-bottom: 4px;
        font-size: 15px;
    }

    .symptom-form>>>.el-form-item__content {
        margin-left: 0 !important;
        width: 100%;
    }

    .symptom-form>>>.radio-container {
        height: auto;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }

    .symptom-form>>>.radio-group {
        position: static;
        right: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
    }

    .symptom-form>>>.radio-button {
        margin: 0;
    }
}
</style>
